import { Center, Spinner, Text } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import {
  useGetSourcingEventQuery,
  useListNegotiationRoundsV2Query,
  type Private,
  type SourcingEventV2Dto,
} from "../../../../../autogen/bff-api";
import { urls } from "../../../../../urls";
import { RoundWizardForm } from "./RoundWizardForm";

export const EditNegotiationRoundWizard = () => {
  const { t } = useTranslation();
  const params = useParams();
  const eventId = params.eventId;
  const roundId = params.roundId;

  const { data: event, isLoading: isLoadingEvent } = useGetSourcingEventQuery(
    eventId ? { eventId } : skipToken,
  );
  const {
    data: roundsData,
    isLoading: isLoadingRounds,
    refetch,
  } = useListNegotiationRoundsV2Query(eventId ? { eventId } : skipToken);

  if (!eventId || !roundId) return <Text>{t("Invalid URL")}</Text>;

  if (isLoadingEvent || isLoadingRounds) {
    return (
      <Center h="40vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  const round = roundsData?.rounds.find((r) => r.id === roundId);

  if (!event || !round) {
    return (
      <Center h="40vh">
        <Text>{t("Could not load event")}</Text>
      </Center>
    );
  }

  if (event.eventContext.type !== "Private") {
    return <Navigate to={urls.v2.sourcingEvents.view.go(event.id)} replace />;
  }

  return (
    <RoundWizardForm
      key={round.id}
      event={event as SourcingEventV2Dto & { eventContext: Private }}
      round={round}
      refetchRound={refetch}
    />
  );
};
